export const getFieldParameters = (apiResponse) =>({
  companyName: apiResponse?.companyName || null,
  companyUEN: apiResponse?.companyUEN || null,
  typeOfCompany: apiResponse?.typeOfCompanyId || null,
  mainContactPerson: Number(apiResponse?.mainContactPersonId) || null,
  mainContactPhoneCountryCode: apiResponse?.contactNumberCountryId || null,
  mainContactPhone: apiResponse?.mainContactPhone || null,
  mainContactEmailAddress: apiResponse?.mainContactEmailAddress || null,
  serviceCategory: Number(apiResponse?.sgbsServiceCategoryId) || null,
  criteriaSelected: apiResponse?.criteriaId || null,
  areYouZCP: apiResponse?.isZCP ? "yes" : "no",
  zcpCategories: Number(apiResponse?.zeroCapitalPartnerId) || null,
});
